<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" size="small" @click="add"
          >新增营销原因</el-button
        >
      </div>
      <div>
        <el-select
          placeholder="请选择状态"
          size="small"
          v-model="searchCondition.status"
          class="mr10"
          clearable
        >
          <el-option label="启用" value="0"></el-option>
          <el-option label="停用" value="1"></el-option>
        </el-select>
        <el-input
          clearable
          style="width: 250px"
          v-model.trim="searchCondition.marketingReason"
          placeholder="请输入营销原因"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="marketingReason"
          label="营销原因"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="remark"
          label="备注"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="添加时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createBy"
          label="添加人"
        ></el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="status"
          label="状态"
        >
        </el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          label="操作"
          width="200"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                size="small"
                type="text"
                @click="updateTemplate(scope.row, 0)"
                :disabled="scope.row.status === 0"
                >停用</el-button
              >

              <el-button
                size="small"
                type="text"
                @click="updateTemplate(scope.row, 1)"
                :disabled="scope.row.status === 1"
                >启用</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="新增营销原因"
      :close-on-click-modal="false"
      @close="dialogVisible = false"
      :visible.sync="dialogVisible"
    >
      <el-form
        label-width="80px"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item label="营销原因" prop="marketingReason">
          <el-input
            maxlength="70"
            placeholder="请输入营销原因(限制70个字符)"
            size="small"
            v-model="ruleForm.marketingReason"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            maxlength="70"
            placeholder="请输入营销原因备注信息"
            size="small"
            :autosize="{ minRows: 4 }"
            type="textarea"
            v-model="ruleForm.remark"
          ></el-input>
          <!-- <div class="form-item-tip">
            店长特批，需要备注店长信息
          </div> -->
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-switch
            v-model="ruleForm.status"
            active-color="#13ce66"
            active-value="1"
            inactive-value="0"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submitReject('ruleForm')" size="small" type="primary"
          >确认</el-button
        >
        <el-button @click="dialogVisible = false" size="small">取消</el-button>
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      dialogVisible: false,
      ruleForm: {
        marketingReason: "",
        remark: "",
        status: false
      },
      rules: {
        marketingReason: {
          required: true,
          message: "请输入营销原因",
          trigger: "change"
        },
        status: {
          required: true
        }
      }
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryMarketingTemplateList",
        params
      );
      const { records, total } = result;

      this.list = records;
      this.total = total;
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    add() {
      this.dialogVisible = true;
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
    },
    updateTemplate(row, status) {
      const params = JSON.parse(JSON.stringify(row));
      params.status = status;
      this.$store.dispatch("updateMarketingTemplate", params).then(res => {
        if (res.code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });

          this.queryList();
        }
      });
    },
    async submitReject(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        // const params = JSON.parse(JSON.stringify(this.ruleForm));
        // params.id = this.row.id;
        // params.state = "2";
        let params = this.ruleForm;
        this.$store.dispatch("saveMarketingTemplate", params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            setTimeout(() => {
              this.resetRuleForm();
            }, 0);
            this.dialogVisible = false;
            this.queryList();
          }
        });
      } else {
        return false;
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
